import React, { Component } from 'react';

let updateImages;
let component;

class ImageUpload extends Component {

	constructor(props) {	
		super(props);
		this.state = {'uploadSource': ''};
    updateImages = props.onAdd;
    component = this;
	}

	componentWillMount() {
    this.fileReader = new FileReader();
    this.fileReader.onloadend = () => {
      this.setState({
        uploadSource: this.fileReader.result,
      });
    };
  }

  _response(response) {
    response.json().then(function(json){
      console.log('Upload Response', json);
      updateImages();
    })
  }

	_uploadImage = () => {

		const form = new FormData(this._form);

    fetch('http://107.170.196.140/upload', {
      method: 'POST',
      body: form,
    }).then(component._response);

	}

	_changeImage = () => {
    this.fileReader.readAsDataURL(this._input.files[0]);
  }


	render() {
		return (
			<div className="control-wrap">
      <span className="control-label">Upload Image</span>
			<form ref={(form) => {this._form = form}} encType="multipart/form-data">
        <input
          name='file'
          onChange={this._changeImage}
          ref={(input) => {this._input = input}}
          type='file'
        />
        <input 
        	type="button"
        	value="Upload"
        	onClick={this._uploadImage}
        	/>
      </form>
 {/*    <img
     	alt='Preview'
     	width='100%'
     	height='auto'
     	src={this.state.uploadSource}
     	/>*/}
     	</div>
		)
	}
}

export default ImageUpload


// WEBPACK FOOTER //
// ./src/controls/ImageUpload.jsx